import { render, staticRenderFns } from "./ListagemLeadlovers.vue?vue&type=template&id=486204dc&scoped=true"
import script from "./ListagemLeadlovers.vue?vue&type=script&lang=js"
export * from "./ListagemLeadlovers.vue?vue&type=script&lang=js"
import style0 from "./ListagemLeadlovers.vue?vue&type=style&index=0&id=486204dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486204dc",
  null
  
)

export default component.exports